import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Main from './sections/Main';
import store from './store';

import { checkLogin } from './store/login';
import { loadFields } from './store/info';

store.dispatch(checkLogin());
store.dispatch(loadFields());

var base_url = window.location.origin;
let cookies = document.cookie;
let state = store.getState(); 

if (!document.URL.match("token")){
  fetch(base_url + "/api/v1/ticket").then(function(resp) {
    let url = null;
    let header = resp.headers;
  
    url = header.get("location");
    if (url != null)
    {
      window.location.replace(url as string);
    }else {
      ReactDOM.render(
        <Provider store={store}>
        <Main />
        </Provider>,
        document.getElementById('root') as HTMLElement
      );
    }
  })
}else{
  ReactDOM.render(
    <Provider store={store}>
    <Main />
    </Provider>,
    document.getElementById('root') as HTMLElement
  );
}






